export default {
  // a mix from popularity, vote count and vote avarage
  setImportanceIndex(movie) {
    const votes = ((movie.vote_average ** 3) * movie.vote_count) / 1000;
    if (movie.popularity) {
      movie.importance = votes + movie.popularity;
    } else {
      movie.importance = votes;
    }
    return movie;
  },
  orderByProperty(items, property, secondaryProperty = 'importance') {
    items.sort((a, b) => {
      if (property === 'importance') return b[property] - a[property];
      return b[property] - a[property] || b[secondaryProperty] - a[secondaryProperty];
    });
    return items;
  },
  setSimilarityIndex(main, secondary) {
    secondary.similarity = main.genre_ids.filter(id => secondary.genre_ids.includes(id)).length;
    return secondary;
  }
};
